import { NEXTJS_RSC_PRODUCT_TILE_LOGGED_IN_SEARCH_PAGE_240729 } from "@faire/web-api--source/indigofair/settings/NEXTJS_RSC_PRODUCT_TILE_LOGGED_IN_SEARCH_PAGE_240729";

import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { shouldShowRscLoggedInSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedInSearchPage";

const getSettingRscProductTileLoggedInSearchPage = (): boolean => {
  return getSettingValueWithoutAssignment(
    NEXTJS_RSC_PRODUCT_TILE_LOGGED_IN_SEARCH_PAGE_240729,
    false
  );
};

export const shouldShowRscProductTileLoggedInSearchPage = (): boolean => {
  return (
    shouldShowRscLoggedInSearchPage() &&
    getSettingRscProductTileLoggedInSearchPage()
  );
};
